import { gql } from "@apollo/client"

export const ROUND_START = gql`
  mutation RoundStart($RoundStartInput: RoundStartInput!) {
    RoundStart(input: $RoundStartInput) {
      status {
        success
        name
        detail
      }
      Round {
        id
        urlView
        urlStanding
      }
    }
  }
`
